<template>
  <AppWrapper>
    <div class="impressum-container">
      <div class="header">
        <span class="grid-text-large">Impressum</span>
      </div>
      <div class="content">
        <div class="last-updated">
          <span class="caption">Letzte Aktualisierung: 19. November 2024</span>
        </div>

        <section class="impressum-section">
          <h2 class="h2">Angaben gemäß § 5 TMG und § 55 RStV</h2>
          <p class="body-text">
            Florian Vates
            <br />
            Matulusstraße 2A
            <br />
            83395 Freilassing
            <br />
            Deutschland
          </p>
        </section>

        <section class="impressum-section">
          <h2 class="h2">Kontakt</h2>
          <p class="body-text">E-Mail: gift-a-habit@florianvates.com</p>
        </section>

        <section class="impressum-section">
          <h2 class="h2">Umsatzsteuer-ID</h2>
          <p class="body-text">
            Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:
            <br />
            DE366477515
          </p>
        </section>

        <section class="impressum-section">
          <h2 class="h2">Entwicklung und technische Umsetzung</h2>
          <p class="body-text">Florian Vates</p>
          <p class="body-text">Sebastian Vates</p>
        </section>

        <section class="impressum-section">
          <h2 class="h2">Streitschlichtung</h2>
          <p class="body-text">
            Die Europäische Kommission stellt eine Plattform zur
            Online-Streitbeilegung (OS) bereit:
            <br />
            <a href="https://ec.europa.eu/consumers/odr/"
              >https://ec.europa.eu/consumers/odr/</a
            >
          </p>
          <p class="body-text">
            Wir sind nicht bereit oder verpflichtet, an
            Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
            teilzunehmen.
          </p>
        </section>

        <section class="impressum-section">
          <h2 class="h2">Haftung für Inhalte</h2>
          <p class="body-text">
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte
            auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
            §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
            verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
            überwachen oder nach Umständen zu forschen, die auf eine
            rechtswidrige Tätigkeit hinweisen.
          </p>
          <p class="body-text">
            Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
            Informationen nach den allgemeinen Gesetzen bleiben hiervon
            unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
            Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei
            Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese
            Inhalte umgehend entfernen.
          </p>
        </section>

        <section class="impressum-section">
          <h2 class="h2">Haftung für Links</h2>
          <p class="body-text">
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren
            Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
            fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
            verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
            der Seiten verantwortlich.
          </p>
          <p class="body-text">
            Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf
            mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
            Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
            inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
            Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei
            Bekanntwerden von Rechtsverletzungen werden wir derartige Links
            umgehend entfernen.
          </p>
        </section>

        <section class="impressum-section">
          <h2 class="h2">Urheberrecht</h2>
          <p class="body-text">
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
            diesen Seiten unterliegen dem deutschen Urheberrecht. Die
            Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
            Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
            schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
          </p>
          <p class="body-text">
            Downloads und Kopien dieser Seite sind nur für den privaten, nicht
            kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser
            Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte
            Dritter beachtet. Insbesondere werden Inhalte Dritter als solche
            gekennzeichnet.
          </p>
        </section>

        <div class="copyright">
          <p class="body-text copyright-text">
            © 2024 Florian Vates. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </div>
  </AppWrapper>
</template>

<script setup>
import AppWrapper from "@/components/AppWrapper.vue";
</script>

<style scoped>
.impressum-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding-bottom: 60px;
}

.header {
  display: flex;
  flex-direction: column;
  justify-content: end;
  padding: 0 20px;
  height: 15vh;
  min-height: 80px;
  width: 100%;
  align-self: center;
}

.grid-text-large {
  margin-bottom: 20px;
}

.content {
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
}

.last-updated {
  margin-bottom: 40px;
}

.impressum-section {
  margin-bottom: 40px;
}

.h2 {
  margin: 25px 0 15px;
  color: var(--Foreground---Primary);
}

.body-text {
  color: var(--Foreground---Secondary);
  font-family: Nunito;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 15px;
}

.copyright {
  margin-top: 60px;
  padding-top: 20px;
  border-top: 1px solid var(--Border);
  width: 100%;
}

.copyright-text {
  text-align: center;
  color: var(--Foreground---Secondary);
  font-size: 14px;
}

/* Mobile Responsiveness */
@media only screen and (max-width: 680px) {
  .impressum-container {
    padding-bottom: 40px;
  }

  .header {
    background-color: var(--Brand);
  }

  .grid-text-large {
    color: #fff;
  }

  .content {
    padding: 15px;
  }

  .impressum-section {
    margin-bottom: 30px;
  }

  .body-text {
    font-size: 14px;
  }
}
</style>
